import { sendGaEvent } from './analytics';

type ShopClickDataset = {
  shopClick?: string;
  shop?: string;
  placement?: string;
  itemId?: string;
  itemTitle?: string;
  platform?: string;
  releaseState?: string;
  purchasePhase?: string;
  recommendation?: string;
  ctaVariant?: string;
};

type ShopClickParams = {
  shop: string;
  placement: string;
  item_id: string;
  item_title: string;
  platform: string;
  release_state?: string;
  purchase_phase?: string;
  recommendation?: string;
  cta_variant?: string;
};

const UNKNOWN_ITEM_TITLE = '(タイトル不明)';

type ShopClickElement = HTMLElement | SVGElement;

function isShopClickElement(value: unknown): value is ShopClickElement {
  return value instanceof HTMLElement || value instanceof SVGElement;
}

export function buildShopClickParams(dataset: ShopClickDataset): ShopClickParams | null {
  const { shop, placement, itemId, itemTitle, platform } = dataset;
  if (!shop || !placement || !itemId || !platform) return null;
  const params: ShopClickParams = {
    shop,
    placement,
    item_id: itemId,
    item_title: itemTitle || UNKNOWN_ITEM_TITLE,
    platform,
  };
  if (dataset.releaseState) params.release_state = dataset.releaseState;
  if (dataset.purchasePhase) params.purchase_phase = dataset.purchasePhase;
  if (dataset.recommendation) params.recommendation = dataset.recommendation;
  if (dataset.ctaVariant) params.cta_variant = dataset.ctaVariant;
  return params;
}

export function findShopClickElement(target: EventTarget | null): ShopClickElement | null {
  const element = target instanceof Element ? target : null;
  const candidate = element?.closest('[data-shop-click]');
  return isShopClickElement(candidate) ? candidate : null;
}

export function trackShopClick(
  dataset: ShopClickDataset,
  tracker: (eventName: string, params: ShopClickParams) => boolean = sendGaEvent,
): boolean {
  const params = buildShopClickParams(dataset);
  if (!params) return false;
  return tracker('shop_click', params);
}

const initializedDocs = new WeakSet<Document>();

export function initShopClickTracking(doc: Document = document): void {
  if (initializedDocs.has(doc)) return;
  initializedDocs.add(doc);

  doc.addEventListener('click', (event) => {
    const el = findShopClickElement(event.target);
    if (!el) return;
    trackShopClick(el.dataset);
  });
}
